import {
  defaultSystemCode,
  exists,
  LendCollection,
  LendCollectionFromJSON,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export interface LendCollectionInfo {
  userId: string
  userName: string
  userType: SystemCode
  userRevision: number
  collections: LendCollection[]
}

export const defaultLendCollectionInfo = (): LendCollectionInfo => ({
  userId: '',
  userName: '',
  userType: defaultSystemCode(),
  userRevision: 0,
  collections: []
})

export function LendCollectionInfoFromJSON(json: any): LendCollectionInfo {
  return LendCollectionInfoFromJSONTyped(json)
}

export function LendCollectionInfoFromJSONTyped(json: any): LendCollectionInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userId: exists(json, 'user_id') ? json.user_id : '',
    userName: exists(json, 'user_name') ? json.user_name : '',
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    userRevision: exists(json, 'user_revision') ? json.user_revision : 0,
    collections: json.collections.map(LendCollectionFromJSON)
  }
}
